import Vue from 'vue';
import axios from 'axios';
import * as files from '@/fileUtils';

export default {
  name: 'CmrContrPnlEditReading_Photos',
  components: {
  },
  props: {
    photoList: {
      type: Array,
      required: true
    },
    scrollTo: {
      type: Function,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      photoToDelete: null,
      deleteConfirmation: false,
      photoListLoader: [],
      showPicDialog: false,
      img: null,
      scrollWatchElem: null,
      photosDataList: [],
      initialNumberOdPhotosToLoad:5,
      scrollPhotoElementNum: 0,
    }
  },
  computed: {
    photoListLength: function() {
      return this.photoList.length;
    },
  },
  watch: {
    photoListLength: function (val) {
      this.fillPhotoListLoaderArr(val);
      //this.getAllPictures(true);
    },
    scrollPhotoElementNum: function (val) {
      if (val > 0) {
        let index = val + this.initialNumberOdPhotosToLoad; //already loaded 5 elements, we are only interested in the rest
        for (let i = 0; i < index; i++) { // if no pic, the get all pics up to that scroll point
          if (!this.photosDataList[i] && !this.photoListLoader[i]) 
            this.viewPicture(this.photoList[i], i);
        }
      }
    },
  },
  created() {
    this.$root.$on('edit_reading_photo_window_init', this.init);
  },
  mounted() {
    this.init();
  },
  beforeUnmount() {
    this.scrollWatchElem.addEventListener('scroll', this.scrollListener);
  },
  methods: {
    scrollListener(event) {
      //264px is the length of the photo element, so every number 1,2,3 we load a new one
      this.scrollPhotoElementNum = Math.floor(event.target.scrollTop / 264);
    },
    async init() {
      this.fillPhotoListLoaderArr(this.photoListLength);

      this.scrollWatchElem = document.getElementById('card-list-11');
      this.scrollWatchElem.addEventListener('scroll', this.scrollListener);

      for (let k = 0; k <= this.initialNumberOdPhotosToLoad; k++) {
       await this.viewPicture(this.photoList[k], k);
      }
    },
    async fillPhotoListLoaderArr(num) {
      this.photoListLoader.length = 0;
      this.photosDataList.length = 0;

      for (let i = 0; i < num; i++) {
        this.photoListLoader.push(false);
        this.photosDataList.push(null);
      }        
    },
    deletePicConfirmation(item, index) {
      this.photoToDelete = item;
      this.deleteConfirmation = true;
      this.indicatorOnOff(index, true);
    },
    deleteConfirmationCancel() {
      this.photoToDelete = null;
      this.deleteConfirmation = false;
      this.indicatorOnOff();
    },
    deletePicture(item) {
      if (this.photoToDelete == null) {
        this.indicatorOnOff();
        return;
      }

      axios.post('/CaptureMeterReading/DeletePhoto', { value: this.photoToDelete.id })
        .then(response => {
          if (response.status == 200)
            this.$oldAlertMsg(this.$t('messages.PhotoDeletedSuccess'), 2);
        })
        .catch(e => {
          this.$oldAlertMsg(this.$t('messages.AttachmentDeletedError') + ' - ' + e, 4);
        })
        .finally(() => {
          this.$root.$emit('get_cmr_photos_list');
          this.indicatorOnOff();
          this.photoToDelete = null;
        });
      
    }, 
    downloadPicture(item, index) {
      this.indicatorOnOff(index, true);

      axios.post("/CaptureMeterReading/DownloadPhoto", { Value: item.id }, { responseType: "blob" })
        .then(files.getFile)
        .then((link) => {
          link.click();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(this.indicatorOnOff(index));
    },
    indicatorOnOff(index, indicatorOn = false) {
      if (index >= 0)
        this.photoListLoader[index] = indicatorOn;
      else 
        for (let i = 0; i < this.photoListLength; i++)
          this.photoListLoader[i] = false;     

      this.$forceUpdate();  
    
    },
    copyToMeter(item, index) {
      this.indicatorOnOff(index, true);

      axios.post('/CaptureMeterReading/CopyPhotoToMeter', { value: item.id })
        .then(response => {
          if (response.status == 200)
            this.$oldAlertMsg(this.$t('captureMR.PhotoAdded2Meter'), 2);
        })
        .catch(e => {
          this.$oldAlertMsg(this.$t('captureMR.PhotoAdded2MeterError') + ' - ' + e, 4);
        })
        .finally(() => {
          this.indicatorOnOff(index);
        });
    },
    async viewPicture(item, index, viewInWindow) {
      if (item == null)
        return;

      this.indicatorOnOff(index, true);
      return await axios.post("/CaptureMeterReading/ViewPhoto", { Value: item.id })
        .then((response) => {
          if (response.data.data.status == 0) {
            let img = 'data:image/jpeg;base64,' + response.data.img;
            if (viewInWindow) {
              this.img = img;;
              this.showPicDialog = true;
            }

            this.photosDataList[index] = img;

            this.indicatorOnOff(index)
            return img;
          }
          else {
            if (viewInWindow)
              this.$oldAlertMsg(response.data.data.text, 4);
            this.indicatorOnOff(index);
            return null;
          }
        })
        .catch((e) => {
          this.$oldAlertMsg(e.message, 4);
          this.indicatorOnOff(index);
        });
    },

    //Dynamic css classes for delete button
    errorButtonClass(index) {
      return this.photoListLoader[index] || this.readOnly ? '' : 'error-button';
    },
    errorButtonIconClass(index) {
      return this.photoListLoader[index] || this.readOnly ? '' : 'color-white';
    },
  }
}
